// Display-only rates from the Q2 2026 pricing mocks. The ledger is currency-free;
// replace with plan-config pricing when the purchase-flow project lands.
export const CREDIT_PRICING = {
  paygUsdPerCredit: 9.99,
  unlimitedOverageUsdPerCredit: 9.99,
} as const;
